import styled from 'styled-components';
import { Flex } from 'reflexbox';

import { isUserRecipient, Recipient } from 'packages/kakapo-ui-services/models/Recipient';
import { ComposableListItem } from 'packages/kakapo-ui-kit/components/lists/ComposableList';
import RecipientFieldControls from 'packages/kakapo-ui-kit/components/recipients/RecipientFieldControls';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import { Avatar, Spinner } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

interface IProps {
	recipient: Recipient;
	onRemove: () => void;
	loading?: boolean;
}

const SpinnerContainer = styled.div`
	display: flex;
	align-items: center;
	height: 30px;
`;

export default function RecipientFieldReadonly({ recipient, onRemove, loading }: IProps) {
	const label = isUserRecipient(recipient)
		? `${recipient.userData.firstName} ${recipient.userData.lastName}`
		: recipient.name;

	return (
		<ComposableListItem
			compact
			controls={
				loading ? (
					<SpinnerContainer>
						<Spinner />
					</SpinnerContainer>
				) : (
					<RecipientFieldControls onRemove={onRemove} />
				)
			}
			accessory={
				isUserRecipient(recipient) ? (
					<Avatar user={recipient.userData} size={24} />
				) : (
					<Avatar
						user={{
							firstName: recipient.name?.toUpperCase(),
							lastName: '',
						}}
						size={24}
					/>
				)
			}
		>
			<Flex>
				<Column>
					<ParagraphSmall color="slateBlue">{label}</ParagraphSmall>
				</Column>
			</Flex>
		</ComposableListItem>
	);
}
